module.exports = __webpack_public_path__ + "static/img/Full-Body1.1322dbbb.jpg";